module.exports = __webpack_public_path__ + "static/media/cut.671565ee.svg";